<template>
  <div class="container text-center error-page">
    <h1>Sorry!</h1>
    <p>{{ message }}</p>
    <a
      class="btn btn-primary"
      @click.prevent="close"
    >Close</a>
  </div>
</template>

<script>
const ERROR_MESSAGES = {
  account_already_exists: 'A Tagboard account with this email already has a Google account connected. Please disconnect your existing Google account and try again.',
};

export default {
  name: 'ErrorPage',
  computed: {
    message() {
      const { error } = this.$route.query;
      return ERROR_MESSAGES[error] || 'Something went wrong. Please try again.';
    },
  },
  methods: {
    close() {
      window.close();
    },
  },
};
</script>
